export default function Section({
  number,
  title,
  children,
}: {
  number: number;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border border-neutral-200 bg-white shadow-sm">
      <div className="border-ink/20 mb-4 flex items-center gap-2 border-b p-4">
        <span className="bg-ink text-surface-elevated flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold">
          {number}
        </span>
        <h3 className="text-sm font-semibold text-neutral-900">{title}</h3>
      </div>
      <div className="space-y-4 p-4">{children}</div>
    </div>
  );
}
